import React from 'react'
import { withSiteData } from 'react-static'
//
import logoImg from '../images/logo.png'

export default withSiteData(() => (
  <div>
    <h1 style={{ textAlign: 'center' }}>Welcome to</h1>
    <img src={logoImg} width="300" alt="" style={{ display: 'block', margin: '0 auto' }} />
  </div>
))



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/Home.js